{
    "Id": "ID KAART:",
    "IdPlaceholder": "[Automatisch toegewezen]",
    "NamePlaceholder": "Instellingen voor centrale beheeromgeving.",
    "BillingId": "Facturerings-ID:",
    "ParentCme": "CME-details",
    "DescriptionIsRequired": "Beschrijving is vereist.",
    "CMEDetails_ButtonHelpLabel": "Helpen?",
    "CMEDetails_ButtonSubmitLabel": "Oke",
    "CMEDetails_ButtonCancelLabel": "Annuleren",
    "CMEDetails_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
    "CMEDetails_PromptConfirm": "Ja",
    "CMEDetails_PromptCancel": "Annuleren",
    "CMEDetails_Description": "Beschrijving:",
    "NAME": "CMEDetails",
    "CMEDetails_ProviderIDS": "SSO Provider ID's:",
    "CMEDetails_ProviderIDS_Help": "Laat leeg tenzij je Single-Sign On (SSO) configureert. Je provider-ID is verstrekt als je SSO gebruikt.",
    "CMEDetails_ProviderIDS_Validation_NoMoreThan5": "Er zijn niet meer dan 5 SSO Provider ID's toegestaan.",
    "CMEDetails_ProviderIDS_Validation_IDsInvalid": "Zorg ervoor dat Provider ID's alleen uit letters, cijfers, koppeltekens of underscores bestaan, niet langer zijn dan 15 tekens en in een door komma's gescheiden lijst staan.",
    "CMEDetails_Disable_Akixi_Login": "Aanmelding via gebruikersnaam uitschakelen:"
}